import { EditOutlined } from "@mui/icons-material";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { Box, textAlign } from "@mui/system";
import { type } from "@testing-library/user-event/dist/type";
import Images from "assets/images";
import { BackButton, CardBox, CustomButton } from "components";
import Image from "components/common/Image";
import { errorAlert } from "helpers/alerts";
import { validatePermission } from "helpers/authentication";
import { currencyFormatter } from "helpers/util";
import React, { useEffect } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCurrentPDSProduct, setCurrentPDSSegment, setJustProducts, setPDSProducts, setPDSSegments } from "redux/slices/client/bagSlice";
import { getAllBagPDSProductsService, getBagPDSProductsService, getBagPDSSegmentsService } from "services/client/bagService";

const BagPDSScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hoster } = useSelector(store => store.session);
  const { currentCommerce } = useSelector((store) => store.commerces);
  const currentBag = currentCommerce.bags.find(bag => bag.type === 'PDS');
  const {
    justProducts,
    pdsSegments,
    pdsProducts,
    currentPDSSegment,
    currentPDSProduct
  } = useSelector((store) => store.bags);

  useEffect(() => {
    getBagPDSSegmentsService(currentBag.id).then(list => {
      dispatch(setPDSSegments(list));
    }).catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (justProducts) {
      getAllBagPDSProductsService(currentBag.id).then(list => {
        dispatch(setPDSProducts(list));
      }).catch(error => errorAlert(error))
    } else {
      if (currentPDSSegment)
        getBagPDSProductsService(currentBag.id, currentPDSSegment.id).then(list => {
          dispatch(setPDSProducts(list));
        }).catch(error => errorAlert(error))
    }

    // eslint-disable-next-line
  }, [currentBag, currentPDSSegment, justProducts]);


  const handlerClickSegment = (segment) => {
    if (segment.id !== currentPDSSegment?.id) {
      batch(() => {
        dispatch(setCurrentPDSSegment(segment));
        dispatch(setCurrentPDSProduct());
      })
    }
  };

  const handlerClickProduct = (product) => {
    if (product.id !== currentPDSProduct?.id) {
      dispatch(setCurrentPDSProduct(product));
    }
  };

  return (
    <Box mt={2} >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate('/cliente/comercios')} />
        </div>
        <div className="container-title">
          <div className="commerce">{currentCommerce.username} </div>
          <div className="bag">{currentBag.username} </div>
        </div>
        <div >
          {
            hoster?.id != currentCommerce._id && <CustomButton
              dark={true}
              icon={<EditOutlined />}
              name={'Administrar'}
              click={() => navigate(justProducts ? "productos" : "segmentos")}
            />
          }
        </div>
      </Grid>
      <Box mt={2} />
      {
        !justProducts && (
          <CardBox
            name={"Segmentos"}
            values={pdsSegments}
            handleSelect={handlerClickSegment}
            isSelect={currentPDSSegment?.id}
            buttons={[
              {
                type: "custom",
                element: <FormControlLabel
                  label={'Ver solo produtos'}
                  control={
                    <Checkbox
                      checked={justProducts}
                      checkedIcon={<Image src={Images.icon.check_square} />}
                      icon={<Image src={Images.icon.uncheck_square} />}
                      onChange={(e) => {
                        dispatch(setJustProducts(e.target.checked))
                      }}
                    />
                  }
                />
              },
            ]}
            formatter={({ idSegment: item }) => ({
              ...item,
              image: `/v3/file/${item.fd}/`,
            })}
          />
        )
      }
      {
        (justProducts || currentPDSSegment) && (
          <CardBox
            name={"Servicios"}
            values={pdsProducts?.filter(({ state }) => state)}
            handleSelect={handlerClickProduct}
            isSelect={currentPDSProduct?.id}
            buttons={[
              hoster?.id != currentCommerce._id && !justProducts && {
                icon: <EditOutlined />,
                key: "products",
                name: "Administrar",
                click: () => navigate("productos"),
              },
              justProducts && {
                type: "custom",
                element: <FormControlLabel
                  label={'Ver solo produtos'}
                  control={
                    <Checkbox
                      checked={justProducts}
                      checkedIcon={<Image src={Images.icon.check_square} />}
                      icon={<Image src={Images.icon.uncheck_square} />}
                      onChange={(e) => {
                        dispatch(setJustProducts(e.target.checked))
                      }}
                    />
                  }
                />
              },
            ]}
            formatter={({ idProduct: item, commission }) => ({
              ...item,
              commission,
              image: `/v3/file/${item.fd}/`,
            })}
            element={({ commission }) => (
              validatePermission("comercios", "comisiones", ["ver"]) && <div style={{ textAlign: 'center' }}>Comisión: {currencyFormatter.format(commission || 0)}</div>
            )}
          />
        )
      }
    </Box >
  );
};

export default BagPDSScreen;
